import {_Books} from "./_Books";
import {_Maps} from "./_Maps";

export const Admin = {
    Books: _Books,
    Maps: _Maps
}